import React from 'react';
import { Box, FormControl, FormHelperText, MenuItem, Select, Typography } from '@mui/material';
import { makeStyles } from 'tss-react/mui';
import clsx from 'clsx';
import { value } from 'lodash/seq';

export const useStyles = makeStyles()((theme) => ({
  typography: {
    color: '#707070',
    marginBottom: '5px',
  },

  disabled: {
    backgroundColor: '#ededed',
    color: '#4a4a4a',
    fontWeight: 600,
  },
}));

function AxlSelect(props) {
  const { classes } = useStyles();
  let { options, size, variant, label, disabled, error, helperText, placeholder, required, value, ...otherProps } = props;

  if (!options || options.length === 0) options = [];

  return (
    <FormControl variant={variant || 'outlined'} size={size || 'small'} fullWidth error={error}>
      <Box>
        {label && (
          <Typography className={classes.typography}>
            {label}
            {required && <span style={{ color: 'red' }}>*</span>}
          </Typography>
        )}
        <Select
          className={clsx(classes.select, disabled && classes.disabled)}
          fullWidth
          disabled={disabled}
          displayEmpty={!!placeholder}
          value={value}
          SelectDisplayProps={{
            style: { color: !value ? '#bbb' : undefined },
          }}
          {...otherProps}
        >
          {placeholder && (
            <MenuItem disabled value="">
              {placeholder}
            </MenuItem>
          )}
          {options.map((item, idx) => (
            <MenuItem value={item.value} key={`${item.value}-${idx}`}>
              {item.label}
            </MenuItem>
          ))}
        </Select>
        {helperText && <FormHelperText>{helperText}</FormHelperText>}
      </Box>
    </FormControl>
  );
}

export default AxlSelect;
